import Cookies from 'js-cookie';
import { logRollout } from './rolloutLog';

export const LEAN_PDP_COOKIE = 'ff_lean_pdp_v4';
const FALLBACK_VARIANT = 'control';
const DAFITI_HOME = 'https://www.dafiti.com.br';

export function redirectLegacyUserToRollout(): boolean {
  let variant = Cookies.get(LEAN_PDP_COOKIE);
  const cookieIn = variant;

  if (!variant) {
    variant = FALLBACK_VARIANT;
    Cookies.set(LEAN_PDP_COOKIE, variant, {
      domain: '.dafiti.com.br',
      expires: 1 / 12,
      path: '/',
      sameSite: 'lax',
      secure: true,
    });
  }

  logRollout(cookieIn, variant, Cookies.get(LEAN_PDP_COOKIE));
  if (variant !== 'on') return false;
  window.location.replace(
    `${DAFITI_HOME}${window.location.pathname}${window.location.search}${window.location.hash}`,
  );
  return true;
}
